import { IPagedListResponse } from "../global/pagedListResponse"
import { FilialResponse } from "./filialResponse"
export const FILIAL_EMPRESA_GET = 'FILIAL_EMPRESA_GET'

export interface FilialState {
    Filiais: IPagedListResponse<FilialResponse> | undefined,
}

export interface FilialEmpresaAction {
    type: typeof FILIAL_EMPRESA_GET,
    payload: IPagedListResponse<FilialResponse>
}

export type FilialActionTypes = FilialEmpresaAction